module.exports = __webpack_public_path__ + "static/media/NUMBERS.2463daf8.svg";